export default __webpack_public_path__ + "static/media/MenuAngoloDabruzzo.c60d5914.pdf";